import type { ComponentChildren } from "preact";
import "./StatusPill.css";

export function StatusPill({
  children,
  tone = "info",
}: {
  children: ComponentChildren;
  tone?: "info" | "warning" | "success";
}) {
  return <span class={`status-pill status-pill--${tone}`}>{children}</span>;
}
